export const pricingTiers = {
  basic_economy:   { daily: 45,  weekly: 200, monthly: 700  },
  full_size_sedan: { daily: 55,  weekly: 250, monthly: 800  },
  newer_sedan_suv: { daily: 65,  weekly: 280, monthly: 900  },
  luxury:          { daily: 75,  weekly: 350, monthly: 1100 },
};

export function buildTransactionPayload(formData, agentId) {
  const { store_id, unit, quantity, isPaid, payment_method, vehicle_class, ...base } = formData;
  const qty = quantity ? parseInt(quantity) : null;

  const payload = {
    ...base,
    customer_id: parseInt(formData.customer_id),
    vehicle_id: formData.vehicle_id ? parseInt(formData.vehicle_id) : null,
    quantity: qty,
    notes: formData.notes || '',
    agent_id: agentId,
    isPaid: !!isPaid,
    payment_method: isPaid ? (payment_method || null) : null,
  };

  if (formData.type === 'fee' || formData.type === 'late_fee') {
    payload.end_date = formData.start_date;
    payload.amount = parseFloat(formData.amount);
    payload.daily_rate = 0;
    payload.insurance_id = null;
    if (!formData.vehicle_id) payload.vehicle_id = null;
  } else {
    const startDate = new Date(formData.start_date);
    const endDate = new Date(startDate);
    if (unit === 'day')        endDate.setDate(endDate.getDate() + qty);
    else if (unit === 'week')  endDate.setDate(endDate.getDate() + qty * 7);
    else if (unit === 'month') endDate.setMonth(endDate.getMonth() + qty);
    payload.end_date = endDate.toISOString().split('T')[0];

    const pricing = vehicle_class ? pricingTiers[vehicle_class] : null;
    if (pricing) {
      const baseAmount = unit === 'day'   ? pricing.daily * qty
                       : unit === 'week'  ? pricing.weekly * qty
                       : pricing.monthly * qty;
      const dailyRate  = unit === 'day'   ? pricing.daily
                       : unit === 'week'  ? pricing.weekly / 7
                       : pricing.monthly / 30;
      payload.amount     = formData.amount ? parseFloat(formData.amount) : baseAmount;
      payload.daily_rate = dailyRate;
    } else {
      payload.amount     = parseFloat(formData.amount);
      payload.daily_rate = 0;
    }
  }

  if (isPaid) {
    payload.payment = {
      amount: payload.amount,
      payment_method,
      payment_date: formData.start_date,
    };
  }

  return payload;
}
